import { Async, attr, Fragment, Value } from '@tempots/dom'
import { Query } from '@tempots/ui'

export interface MarkdownOptions {
  markdown: Value<string>
}

export function Markdown({ markdown }: MarkdownOptions) {
  return Async(import('marked'), ({ parse }) => {
    const converted = Value.toSignal(markdown).map((v) =>
      parse(v, { async: false })
    )
    return Fragment(attr.class('markdown prose'), attr.innerHTML(converted))
  })
}

export function MarkdownFromUrl({ url }: { url: Value<string> }) {
  return Query<string, string, string>({
    request: url,
    load: async ({ request }) => {
      const response = await fetch(request)
      return await response.text()
    },
    success: (response) => {
      return Markdown({ markdown: response.value })
    },
  })
}
